import { FREE_TRIAL_DAYS } from 'constants/billing';
import { useTranslation } from 'react-i18next';
import { transformToCdnUrl } from 'utils/google-storage-util';
import { WelcomeCardPlanFeatures } from '../../welcome-card/components/WelcomeCardPlanFeatures';
import { WelcomeCard } from '../../welcome-card/WelcomeCard';
import { useUpgradePlan } from 'hooks/billing/useUpgradePlan';

// Welcome card for shops without a subscription yet
export const DashboardWelcomeCard: React.FC = () => {
    const { t } = useTranslation();
    const { name: upgradePlanName, handle: upgradePlanHandle } = useUpgradePlan();

    return (
        <WelcomeCard
            eyebrow={t('DASHBOARD.WELCOME_CARD.EYEBROW')}
            title={t('DASHBOARD.WELCOME_CARD.TITLE')}
            description={t('DASHBOARD.WELCOME_CARD.DESCRIPTION', { count: FREE_TRIAL_DAYS, plan: upgradePlanName })}
            image={{
                src: transformToCdnUrl('embedded-assets/tiles/integration-design-tile.webp'),
                alt: 'integration-design',
            }}
        >
            <WelcomeCardPlanFeatures
                plans={[
                    { handle: 'free', label: 'Free', icon: 'rocket' },
                    { handle: upgradePlanHandle, label: upgradePlanName, icon: 'bolt' },
                ]}
            />
        </WelcomeCard>
    );
};
